import { loanActivityApi } from 'app/services/api';
import {
  DISCLOSURE_ACTIVITY_EVENT_TYPES,
  DISCLOSURE_ACTIVITY_MAX_ENTRIES,
} from 'app/shared/modules/DisclosureDelivery/DisclosureDelivery.constants';
import { getIsDisclosureActivityUnavailableStatus } from 'app/shared/modules/DisclosureDelivery/DisclosureDelivery.utils';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const DISCLOSURE_ACTIVITY_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/disclosureActivity`,
  {
    GET_ACTIVITY: 'GET_ACTIVITY',
  },
);

const EVENT_TYPES_PARAM = DISCLOSURE_ACTIVITY_EVENT_TYPES.join(',');

// Not wrapped in catchAsyncActionError: the endpoint is behind DEV-4626 and may be un-deployed, so a
// 404/403 must degrade silently (no toast, no rethrow) rather than surface as an error. Any other
// failure is also swallowed so a transient outage never crashes or spams the strip; the previous
// entries simply persist until the next poll.
export const getDisclosureActivityAction =
  ({ applicationId } = {}) =>
  async dispatch => {
    if (!applicationId) {
      return;
    }

    try {
      const { data } = await loanActivityApi.getDisclosureActivity({
        applicationId,
        eventTypes: EVENT_TYPES_PARAM,
        take: DISCLOSURE_ACTIVITY_MAX_ENTRIES,
      });

      dispatch({
        type: DISCLOSURE_ACTIVITY_ACTION_TYPE.GET_ACTIVITY,
        payload: { entries: data?.items ?? [], isUnavailable: false },
      });
    } catch (error) {
      if (getIsDisclosureActivityUnavailableStatus(error?.response?.status)) {
        dispatch({
          type: DISCLOSURE_ACTIVITY_ACTION_TYPE.GET_ACTIVITY,
          payload: { entries: [], isUnavailable: true },
        });
      }
    }
  };
